import axiosInstance from '../../../../config/axiosInstance';
import { ClientValidation } from "../../View/Validation/ClientValidation";

const handleChange = (event, formData, setFormData) => {
  const { name, value } = event.target;
  setFormData({
    ...formData,
    [name]: value,
  });
};



const handleSubmit = async (formData, setFormData, setErrors, redirectCallback, redirectClientList) => {
  formData.Line1 = "";
  formData.Line2 = "";
  formData.Line3 = "";
  const formErrors =  ClientValidation(formData);
  setErrors(formErrors);

  if (Object.keys(formErrors).length === 0) {
    try {
      const response = await axiosInstance.post(`/SuperAdmin/CreateCompany`, formData);
      redirectClientList();
    } catch (error) {
      console.error('Error posting data:', error);
    }
  }
};
const handleUpdate = async (formData, setFormData, setErrors, redirectCallback, redirectClientList) => {
  const token = localStorage.getItem('token');
  if (!token || token == "null") {
    console.error('Token is missing or invalid.');
    redirectCallback();
    return; // Return early to prevent further execution
  }

  formData.Line1 = "";
  formData.Line2 = "";
  formData.Line3 = "";
  const formErrors = ClientValidation(formData);
  setErrors(formErrors);

  if (Object.keys(formErrors).length === 0) {
    try {
      const response = await axiosInstance.post(`/SuperAdmin/UpdateAdminCompany`, formData);
      return response;
    } catch (error) {

      console.error('Error posting data:', error);
    }
  }
};

export { handleChange, handleSubmit, handleUpdate };